import React from 'react';
import { Section } from './ui/Section';
import { XCircle, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <>
      <Section background="white" data-id="element-138">
        <h2 className="text-2xl font-bold text-[#1e3a5f] mb-5 text-center" data-id="element-139">
          El problema real (sin culpas)
        </h2>

        <div className="prose prose-sm md:prose-base text-[#2d3748] mx-auto" data-id="element-140">
          <p className="mb-4" data-id="element-141">
            Si estás aquí, no es porque "no pongas límites". Es porque ya los
            intentaste… y no se sostuvieron.
          </p>

          <ul className="space-y-3 mb-5" data-id="element-142">
            {['Quitaste el celular y explotó.', "Dijiste 'solo una hora' y se volvió tres.", 'Prometiste ser firme… pero estabas cansado, con culpa, o con mil cosas.', 'Y cuando cediste, aprendieron algo peligroso: insistir funciona.'].map((item, i) => <li key={i} className="flex items-start bg-red-50 p-3 rounded-lg" data-id="element-143">
                <XCircle className="w-5 h-5 text-[#dc4a3d] mr-2 flex-shrink-0 mt-0.5" data-id="element-144" />
                <span className="text-sm" data-id="element-145">{item}</span>
              </li>)}
          </ul>

          <p className="mb-4 text-sm md:text-base" data-id="element-146">
            Esto no es un defecto de carácter de tu hijo. Y no es que tú seas un
            mal papá/mamá.
          </p>

          <div className="bg-[#1e3a5f] text-white p-4 rounded-xl shadow-lg text-center my-5" data-id="element-147">
            <p className="font-bold text-base mb-1" data-id="element-148">Es un ciclo biológico:</p>
            <p className="text-blue-100 text-sm" data-id="element-149">
              Pantalla → calma instantánea → más pantalla → menos tolerancia al
              aburrimiento → más pantallas.
            </p>
          </div>

          <p className="text-sm md:text-base" data-id="element-150">
            Hasta que un día te descubres discutiendo con un niño por un
            aparato… y sintiendo que algo se te está yendo de las manos.
          </p>
        </div>
      </Section>

      <Section background="cream" data-id="element-151">
        <div className="max-w-3xl mx-auto" data-id="element-152">
          <h2 className="text-xl font-bold text-[#1e3a5f] mb-4 flex items-center justify-center" data-id="element-153">
            <AlertCircle className="w-6 h-6 text-[#dc4a3d] mr-2" data-id="element-154" />
            Lo que este ebook NO es
          </h2>

          <div className="grid md:grid-cols-2 gap-3" data-id="element-155">
            {['No es un discurso moralista.', "No es 'cero pantallas' sin contexto.", 'No es teoría eterna.', "No es 'pon límites' y ya."].map((item, i) => <div key={i} className="bg-white p-3 rounded-lg shadow-sm border border-gray-100 flex items-center" data-id="element-156">
                <span className="w-2 h-2 bg-[#1e3a5f] rounded-full mr-2" data-id="element-157"></span>
                <span className="text-[#2d3748] font-medium text-sm" data-id="element-158">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-center mt-5 text-base font-medium text-[#1e3a5f]" data-id="element-159">
            Es un plan para hogares reales: cansancio real, niños reales,
            escuela real, trabajo real.
          </p>
        </div>
      </Section>
    </>;
}